export default {
    route: {
        index: '首页',
        dispatchCenter: '调度中心',
        dispatchOrder: '发车单管理',
        dispatchOrderDetail: '发车单明细',
        receiptSign: '回单签收',
        transferCreate: '移交创建',
        transferConfirm: '移交确认',
        alibabaServices: '菜鸟增值服务',
        alibabaServicesSingle: '菜鸟增值服务单',
        taskCenter: '任务中心',
        taskCenterDetail: '任务中心明细',
        orderCenter: '订单中心',
        configCenter: '配置中心',
        type: '项目类型分类',
        charge: '装卸计费规则',
        distribution: '配送方式规则',
        orderCenterDetail: '订单中心明细',
        thirdParty: '是否第三方',
        orderSplit: '订单拆单规则',
        billingService: '业务类型配置',
        assignment: '任务下发规则',
        storehouse: '仓库配置',
        wms: 'WMS出入库确认规则',
        upstream: '上游出入库规则',
        distributeManage: '配送管理',
        vehicleManagement: '车辆管理',
        trafficTrajectory: '行车轨迹',
        timeManage: '时效管理',
        agingProduct: '时效产品',
        reportManage: '报表管理',
        customer: '客户配置',
        monitorManage: '监控管理',
        orderException: '订单异常监控',
        customerPrescription: '客户时效',
        orderWarhouse: '订单分仓规则',
        reportIndex: '报表页面',
        mileage: '里程',
        shipmentQuantity: '起运方量',
        personManage: '工作管理台',
        areaRules: '片区规划',
        stockAdjust: '库存调整申请',
        virtualCustomer: '虚拟客户配置',
        stockManage: '库存管理',
        inventoryFlow: '库存流水',
        reportOMS: 'OMS开单未提',
        reportWMS: 'WMS开单未提',
        reportOrder: '订单全程跟踪报表',
        vehicleFreePlatform: '无车平台推送日志',
        siteCorrection: '地址纠错',
        stockCenter: '库存中心',
        stockMove: '库存初始化',
        accessStock: '出入库确认(反馈上游)',
        omscException: '异常登记',
        orderPanel: '城配-订单看板-全局',
        evaluateQuery: '客评查询',
        transportPage: '运输单管理',
        transportDetails: '运输单明细',
        inTransitTracking: '在途跟踪',
        abnormalBilling: '异常费用申请',
        sieveSingleRule: '筛单规则',
        sieveSingleCenter: '筛单查询',
        singleListDetail: '排单明细',
        singleList: '排单列表',
        limitLineAreas: '限行区域',
        algorithmParameters: '算法参数',
        trainList: '车次列表',
        trainListAdjust: '车次调整',
        trainListDetail: '车次明细',
        waybillDetail: '运输单明细',
        pDispatchOrderDetail: '发车单明细',
        appointmentCenter: '预约中心',
        appointmentCenterDetail: '预约详情',
        basePlatoon: '基地排车',
        orderManageOrderDetail: '订单中心明细',
        orderManageTaskDetail: '任务中心明细',
        PaymentDurationDetail: '配置详情',
        PaymentDurationMip: '审批详情',
        DriverExpenseManageMip: '异常申诉审批明细',
        visualMapLayout: '地图排车',
        collusionWarningMap: '串货预警明细'
    }
};
